import {create} from "zustand";

export const useBasketStore = create((set) => ({
    basketProducts: [],

    // Количество товаров в корзине
    basketCount: 0,

    // Выбранный способ оплаты
    paymentMethod: '',

    // Сумма бонусов, подлежащая списанию
    subtractBonuses: null,

    // Промо код
    promoCodeValue: null,

    // Примененные сертификаты
    certificateData: [],

    init: (props) => {
        const {basketData = {}, config = {}} = props;
        const {basketSettings = {}, defaultPaymentMethod = '', paymentMethod = {}} = config;
    },

    setBasketProducts: (basketProducts) => set(() => ({
        basketProducts,
        basketCount: basketProducts.reduce((sum, el) => sum + Number(el.count), 0)
    })),
}));
